import { useMemo } from "react";
import SearchableSelect, {
  SearchableOption,
} from "@/components/atoms/SearchableSelect";
import { useGetAvailableBrands } from "@/hooks/use-get-available-brands";
import { useOrdersStore } from "./use-orders-store";

export default function OrderBrandFilter() {
  const { availableBrands, isLoadingUser } = useGetAvailableBrands();
  const brandFilter = useOrdersStore((state) => state.brandFilter);
  const setBrandFilter = useOrdersStore((state) => state.setBrandFilter);

  // Convert brands to SearchableSelect options
  const brandOptions: SearchableOption[] = useMemo(() => {
    return availableBrands.map((brand) => ({
      value: brand.id,
      label: brand.name,
    }));
  }, [availableBrands]);

  // Handle brand selection
  const handleBrandChange = (value: string | number | (string | number)[]) => {
    if (Array.isArray(value)) {
      // Handle multiple selection (not expected in this case, but for safety)
      return;
    }

    if (value === "all") {
      setBrandFilter("all");
    } else {
      setBrandFilter(Number(value));
    }
  };

  // Don't render if still loading user data
  if (isLoadingUser) {
    return (
      <div className="w-48 h-10 bg-gray-100 animate-pulse rounded-lg"></div>
    );
  }

  // Don't render if no brands available
  if (brandOptions.length === 0) {
    return null;
  }

  return (
    <SearchableSelect
      options={brandOptions}
      value={brandFilter === "all" ? "all" : brandFilter}
      onValueChange={handleBrandChange}
      placeholder="Marcas"
      searchPlaceholder="Buscar marcas..."
      allOptionLabel="Todas las marcas"
      showAllOption={true}
      width="w-full"
      noResultsText="No se encontraron marcas"
      searchPromptText="Escribe para buscar..."
      multiple={false}
    />
  );
}
